/*
  Wrapper/bundle for react-telephone-input to be used across the app
  Bundles CSS + Flag assets so you can easily drop this component anywhere in the app
*/

import React, { Component } from 'react';
import ReactTelInput from 'react-telephone-input';
import flags from './flags.png';
import './index.scss';

class PhoneInput extends Component {
  render() {
    return (
      <ReactTelInput
        defaultCountry="us"
        preferredCountries={['us', 'gb', 'se']}
        flagsImagePath={flags}
        {...this.props}
      />
    );
  }
}

export default PhoneInput;
